let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("KhCwB"), load("6c9wI")]).then(() => parcelRequire('ffp8s'));